import { formatDate, TABLE_DATE_FORMAT_OPTIONS } from '@/lib/format';

/**
 * Constants and utilities for table display formatting
 */

/**
 * Empty value placeholder for table cells
 */
export const EMPTY_TABLE_VALUE = '♾️';

/**
 * Formats a date for table display using standard format
 * Returns EMPTY_TABLE_VALUE if date is null or invalid
 */
export const formatTableDate = (date: string | null | undefined): string => {
  if (!date) {
    return EMPTY_TABLE_VALUE;
  }

  const formatted = formatDate(date, TABLE_DATE_FORMAT_OPTIONS);

  return formatted || EMPTY_TABLE_VALUE;
};
